import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/content';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  size?: 'md' | 'lg';
  full?: boolean;
};
export function CtaButton({
  label,
  sublabel,
  size = 'lg',
  full = false
}: CtaButtonProps) {
  return <div className={full ? 'w-full' : 'inline-block'} data-id="element-68" data-mp="cn5bv97eyb08">
      <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} className={['group inline-flex w-full items-center justify-center gap-3 rounded-sm bg-acid font-display uppercase leading-none text-night', 'transition-[transform,background-color] duration-150 ease-smooth', 'hover:bg-white hover:-translate-y-0.5 active:translate-y-0', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-acid focus-visible:ring-offset-2 focus-visible:ring-offset-night', size === 'lg' ? 'px-8 py-5 text-2xl sm:text-3xl' : 'px-6 py-4 text-xl sm:text-2xl'].join(' ')} data-id="element-69" data-mp="qj93cuqwk590">
        <span className="text-center" data-id="element-70" data-mp="3a0u6k47r5xqw">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-71" data-mp="3ewsxnzkgttv0" />
      </a>
      {sublabel && <p className="mt-3 text-center text-xs font-medium uppercase tracking-[0.18em] text-white/45" data-id="element-72" data-mp="3ouywg8az6jvn">
          {sublabel}
        </p>}
    </div>;
}